import { MdDashboard } from "react-icons/md";

import { paths, permissions } from "@router";
import { IJobGrade } from "@/types";

import {
  FaUsers,
  FaBuilding,
  FaCog,
  FaIndustry,
  FaBriefcase,
  FaList,
} from "react-icons/fa";

const { admin, client } = paths;

const CustomIconWrapper = () => <FaBuilding size={18} />;
const CustomUsersIconWrapper = () => <FaUsers size={18} />;
const CustomDashboardIconWrapper = () => <MdDashboard size={18} />;

export interface IConfig {
  title: string;
  icon: any;
  path: string; // no more array
  matchPaths?: string[]; // used for matching only
  routingPath?: string;
  sub?: IConfig[];
  permission?: string | Array<string>;
  client?: boolean;
  disabled?: boolean;
  fallbackMessage?: string;
}

export const client_config = (
  jobGrades: IJobGrade[],
  company_id: string,
  user_role: string
): Array<IConfig> => [
  {
    title: "Apps",
    icon: CustomDashboardIconWrapper,
    path: paths.ssoRoute.apps.apps,
  },
  {
    title: "My Company",
    icon: CustomIconWrapper,
    path: paths.admin.users.companies.profile.details.replace(
      ":company_id",
      company_id
    ),
  },
  {
    title: "Company Users",
    icon: CustomUsersIconWrapper,
    path: paths.admin.users.company_users.listing.replace(
      ":company_id",
      company_id
    ),
  },
  {
    title: "Settings",
    icon: FaCog,
    path: admin.settings.tom_users.listing,
    matchPaths: [
      // JF Work
      admin.settings.company_job_function.listing,
    ],
    sub: [
      // JF Work
      {
        title: "Company Job Function & Sub-Function",
        icon: FaBriefcase,
        path: client.settings.company_job_function.listing,
        permission: permissions.VIEW_COMPANY_JOB_FUNCTION,
      },
    ],
  },
];

export const admin_config = (
  company_id: string,
  user_role: string
): Array<IConfig> => [
  {
    title: "Apps",
    icon: CustomDashboardIconWrapper,
    path: paths.ssoRoute.apps.apps,
  },
  {
    title: "Companies",
    icon: CustomIconWrapper,
    path: admin.users.companies.listing,
    matchPaths: [
      admin.users.companies.listing,
      admin.users.companies.create,
      admin.users.companies.edit,
      admin.users.companies.profile.details,
      admin.users.companies.profile.business_units.listing,
      admin.users.companies.profile.business_units.regions,
      admin.users.companies.profile.business_units.countries,
      admin.users.companies.profile.business_units.legal_entities,
      admin.users.companies.profile.regions,
    ],
  },
  {
    title: "Company Users",
    icon: CustomUsersIconWrapper,
    path: admin.users.company_users.company_user,
    matchPaths: [
      admin.users.company_users.company_user,
      admin.users.company_users.listing,
      admin.users.company_users.create,
      admin.users.company_users.edit,
    ],
  },
  {
    title: "Settings",
    icon: FaCog,
    path: admin.settings.tom_users.listing,
    matchPaths: [
      admin.settings.tom_users.listing,
      admin.settings.tom_users.create,
      admin.settings.tom_users.edit,
      admin.settings.sectors.listing,
      admin.settings.sectors.industry,
      admin.settings.sectors.sub_industry,
      admin.settings.job_function.listing,
      admin.settings.job_function.sub_job_function,
      admin.settings.grade_map_table.listing,
      admin.settings.grade_map_table.create_grade_company,
      admin.settings.grade_map_table.edit_grade_company,
      // JF Work
      admin.settings.company_job_function.listing,
      admin.settings.company_functions_map_table.listing,
      "/settings/companies",
    ],
    sub: [
      {
        title: "Tom Users",
        icon: FaUsers,
        path: admin.settings.tom_users.listing,
        permission: permissions.VIEW_SECTOR,
      },
      {
        title: "Sectors, Industry & Sub-Industry",
        icon: FaIndustry,
        path: admin.settings.sectors.listing,
        permission: permissions.VIEW_SECTOR,
      },
      {
        title: "Job Function & Sub-Function",
        icon: FaBriefcase,
        path: admin.settings.job_function.listing,
        permission: permissions.VIEW_JOB_SUB_FUNCTION,
      },
      {
        title: "Grade map table",
        icon: FaList,
        path: admin.settings.grade_map_table.listing,
      },

      // JF Work
      {
        title: "Company Job Function & Sub-Function",
        icon: FaBriefcase,
        path: admin.settings.company_job_function.listing,
        // permission: permissions.VIEW_JOB_SUB_FUNCTION,
      },
      {
        title: "Company Functions Map Table",
        icon: FaList,
        path: admin.settings.company_functions_map_table.listing,
      },
    ],
  },
];
